module.exports = __webpack_public_path__ + "img/code.1f0b5590.png";